import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdministratorAndRoles } from '@mytypes';
import { Response as AdminAndRolesResponse } from '~/common/types/apiResponse/administratorAndRoles';
import { fetchAdminAndRoles } from '~/api';

type AdminAndRoleState = AdministratorAndRoles[];

const initialState: AdminAndRoleState = [];

const adminAndRoleSlice = createSlice({
  name: 'adminAndRoles',
  initialState,
  reducers: {
    initialize: () => initialState,
  },
  // 非同期はextraReducersで行う
  extraReducers: (builder) => {
    builder.addCase(
      fetchAdminAndRoles.fulfilled,
      (state, action: PayloadAction<AdminAndRolesResponse>) => action.payload.result
    );
  },
});

// reducerをexportする
export default adminAndRoleSlice.reducer;
